enum ProviderStatus {
    Free = 1,
    Processing,
    Unsynced
}

export default ProviderStatus